import { render, staticRenderFns } from "./boulder_lab_submissions.vue?vue&type=template&id=8cc378b4&"
import script from "./boulder_lab_submissions.vue?vue&type=script&lang=js&"
export * from "./boulder_lab_submissions.vue?vue&type=script&lang=js&"
import style0 from "./boulder_lab_submissions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports